import { render, staticRenderFns } from "./ExampleMain.vue?vue&type=template&id=01fc407b&scoped=true"
import script from "./ExampleMain.vue?vue&type=script&lang=js"
export * from "./ExampleMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc407b",
  null
  
)

export default component.exports